/* global $:true */
import plugin from '../../lib/plugin';
import { onAvailable } from "../../lib/selectors";

const ELEMENT_SELECTOR = '[data-field-toggle]';
const PLUGIN_NAME = 'fieldToggle';

export function exec() {
	onAvailable.ready(ELEMENT_SELECTOR, function (element) {
		System.import(
			/* webpackChunkName: "plugin--field-toggle" */ "./field-toggle"
		).then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/field-toggle/index.js